import { useQuery, useLazyQuery } from "@apollo/react-hooks";
import React, { useState, useEffect, Fragment } from "react";
import moment from "moment";
import { DatePicker, Button, Select, Tooltip, Space, List } from "antd";
import { Column } from '@ant-design/plots';

import { GET_DASHBOARD_2_CHILD_COUNT_BY_DATE } from "../graphql/modules";
import { warnNotify } from "../util";

const { RangePicker } = DatePicker;

export const DashboardV2D2 = () => {
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [childPermitType, setChildPermitType] = useState('A');
    const [selectedSites, setSelectedSites] = useState([]);

    const [GetDashboard2Data, { data: dashboard2Data, loading: dashboard2Loading, error: dashboard2Error }] = useLazyQuery(GET_DASHBOARD_2_CHILD_COUNT_BY_DATE, {
        variables: {
            startDate: startDate,
            endDate: endDate,
            childPermitType: childPermitType,
            sites: selectedSites,
        },
        fetchPolicy: "cache-and-network",
    });

    const data =[
        {
            "title": "B1 - Hotworks",
            "childPermitType": "B1",
            "approved": 0,
            "pendingClosure": 0,
            "completed": 0,
            "count": 0
        },
        {
            "title": "B2 - CONFINED SPACE",
            "childPermitType": "B2",
            "approved": 0,
            "pendingClosure": 0,
            "completed": 0,
            "count": 0
        },
        {
            "title": "B3 - LIFTING",
            "childPermitType": "B3",
            "approved": 0,
            "pendingClosure": 0,
            "completed": 0,
            "count": 0
        },
        {
            "title": "B4 - Work At Height",
            "childPermitType": "B4",
            "approved": 0,
            "pendingClosure": 0,
            "completed": 0,
            "count": 0
        },
        {
            "title": "B5 - LSS IMPAIRMENT PERMIT",
            "childPermitType": "B5",
            "approved": 0,
            "pendingClosure": 0,
            "completed": 0,
            "count": 0
        },
        {
            "title": "B6 - LIVE ELECTRICAL PERMIT",
            "childPermitType": "B6",
            "approved": 0,
            "pendingClosure": 0,
            "completed": 0,
            "count": 0
        },
        {
            "title": "B7 - SIPP PERMIT",
            "childPermitType": "B7",
            "approved": 0,
            "pendingClosure": 0,
            "completed": 0,
            "count": 0
        },
        {
            "title": "B8 - Dirty Permit",
            "childPermitType": "B8",
            "approved": 0,
            "pendingClosure": 0,
            "completed": 0,
            "count": 0
        }
    ];

    const transformData = (data) => {
        return data?.map(item => ({
          title: item.title,
          childPermitType: item.childPermitType,
          count: item.total,
        }));
    };

    const config = {
        xField: 'childPermitType',
        yField: 'count',
        style: {
            inset: 5,
        },
        tooltip: {
            title: 'title', // 标题
            domStyles: {
                'g2-tooltip': {
                    maxWidth: '300px',
                },
            },
        },
        label: {
            text: (originData) => {
                const val = parseFloat(originData.value);
                if (val < 0.05) {
                    return (val * 100).toFixed(1) + '%';
                }
                return '';
            },
            offset: 10,
        },
    };

    const handleDateFrom = (dates, dateStrings) => {
    if (dates) {
        const formattedDates = dates.map(date => date.format('YYYY-MM-DD'));
        console.log(formattedDates);
        setStartDate(formattedDates[0]);
        setEndDate(formattedDates[1]);
    } else {
        console.log('No dates selected');
    }
    };

    const handleChildPermitTypeChange = (value) => {
        setChildPermitType(value);
    };

    const handleSiteChange = (value) => {
        setSelectedSites(value);
    };

    const handleSubmit = () => {
            console.log('Start Date: ', startDate);
            console.log('End Date: ', endDate);
            console.log('Child Permit Type: ', childPermitType);
            console.log('Selected Sites: ', selectedSites);
            if(startDate !== '' && endDate !== '' || childPermitType !== '' || selectedSites.length > 0) {
                GetDashboard2Data();
            }

            if(startDate === '' || endDate === '') {
                warnNotify('Please select date range');
            }

            if (childPermitType === '') {
                warnNotify('Please select permit type');
            }
            
            if (selectedSites.length <= 0) {
                warnNotify('Please select atleast one site');
            }
    }

    return (
        <Fragment>

            <div className="row dec-row">
                <div className="card">
                <div className="col-12 col-md-12">
                    <div className="col-12 col-md-12 text-left">
                        <h4 className="text-left">Child Permit by Date Range</h4>
                    </div>

                    <div className="row dec-row">
                        <div className="col-12 col-md-12">
                            <div className="col-4 col-md-4">
                                    <Space
                                        className="col-12 col-md-12"
                                        direction="vertical"
                                        size="middle"
                                        // style={{
                                        // display: 'flex',
                                        // }}
                                    >

                                        <div className="col-12 col-md-12">
                                            <RangePicker
                                                style={{ width: "100%" }} 
                                                id={{
                                                    start: 'startInput',
                                                    end: 'endInput',
                                                  }}
                                                onChange={handleDateFrom}
                                            />
                                        </div>

                                        <div className="col-12 col-md-12">
                                            <Select
                                                defaultValue={childPermitType}
                                                placeholder="Please select permit type"
                                                    style={{
                                                        width: '100%',
                                                    }}
                                                    onChange={handleChildPermitTypeChange}
                                                    options={[
                                                        {
                                                            value: 'A',
                                                            label: 'A Permit (A1 - A12)',
                                                        },
                                                        {
                                                            value: 'B',
                                                            label: 'B Permit (B1 - B8)',
                                                        },
                                                        {
                                                            value: 'C',
                                                            label: 'C Permit (C1)',
                                                        },
                                                    ]}
                                                />
                                        </div>

                                        <div className="col-12 col-md-12">
                                            <Select
                                                    mode="multiple"
                                                    allowClear
                                                    placeholder="Please select site(s)"
                                                    style={{
                                                        width: '100%',
                                                    }}
                                                    onChange={handleSiteChange}
                                                    maxTagCount="responsive"
                                                    maxTagPlaceholder={(omittedValues) => (
                                                        <Tooltip
                                                        styles={{
                                                            root: {
                                                            pointerEvents: 'none',
                                                            },
                                                        }}
                                                        title={omittedValues?.map(({ label }) => label).join(', ')}
                                                        >
                                                        <span>...</span>
                                                        </Tooltip>
                                                    )}
                                                    options={
                                                        [
                                                            {
                                                                value: "604a288405a8ed2d4d4bba4b",
                                                                label: "Fab 10A1",
                                                            },
                                                            {
                                                                value: "604a286b05a8ed2d4d4bba4a",
                                                                label: "Fab 10A2",
                                                            },
                                                            {
                                                                value: "604a28bb05a8ed2d4d4bba4c",
                                                                label: "Fab 10N",
                                                            },
                                                            {
                                                                value: "60cafd5a4e8783df2ab8afff",
                                                                label: "Fab 10NX",
                                                            },
                                                            {
                                                                value: "6052a5b7be761a25aaec1bd1",
                                                                label: "Fab 10W",
                                                            },
                                                            {
                                                                value: "604a28ee05a8ed2d4d4bba4e",
                                                                label: "Fab 10X",
                                                            }
                                                        ]
                                                    }
                                                />
                                        </div>

                                        <div className="col-12 col-md-12">
                                            <Button
                                                style={{
                                                    width: '100%',
                                                }}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleSubmit();
                                                }}
                                            >
                                                Submit
                                            </Button>
                                        </div>

                                        <div className="col-12 col-md-12">
                                            <div style={{maxHeight: '311px', overflowY: 'auto'}}>
                                                <List
                                                    size="small"
                                                    dataSource={(dashboard2Data && dashboard2Data.GetChildPermitCountByDateRange.results ? transformData(dashboard2Data.GetChildPermitCountByDateRange.results.tableData) : data).map(v => v.title)}
                                                    renderItem={(item) => <List.Item>{item}</List.Item>}
                                                />
                                            </div>
                                        </div>

                                    </Space>
                            </div>

                            <div className="col-8 col-md-8">
                                    <div className="card">
                                        <Column 
                                            {...config} 
                                            loading={dashboard2Loading}
                                            data={dashboard2Data && dashboard2Data.GetChildPermitCountByDateRange.results ? transformData(dashboard2Data.GetChildPermitCountByDateRange.results.tableData) : data}
                                        />
                                    </div>
                                    <p><i>Permit status: Approved, Pending Closure, Completed</i></p>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </Fragment>
    )
}